/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningCircleIcon20Solid = forwardRef('WarningCircleIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-6.875 3.879a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM11 6.5a1 1 0 0 0-2 0v3.75a1 1 0 0 0 2 0V6.5Z" })));
});
